// @ts-nocheck
// TODO come back to fix breakpoints

import breakpoints from './breakpoints'

export const containterMaxWidth = breakpoints.lg

export default [breakpoints.sm, breakpoints.md, breakpoints.lg, breakpoints.xl]
